module.exports = __webpack_public_path__ + "img/flow.f6c7d11b.svg";